//(function () {
//    'use strict';

//    const module = angular.module('imApp');

//    module.component('consignmentSplit', {
//        templateUrl: 'views/components/views/consignmentSplit/consignmentSplit.template.html?v=' + module.version,
//        controllerAs: 'vm',
//        controller: ['$stateParams', 'translateService', 'modalService', 'stateService', 'utilityService', 'consignmentSplitService', function ($stateParams, translateService, modalService, stateService, utilityService, consignmentSplitService) {

//            // #region VARIABLES & DEFINITIONS

//            const vm = this;
//            let consignmentKeynoSplitFrom = $stateParams.consignment_keyno_splitfrom;

//            let translations = {
//                error: '',
//                ok: ''
//            };

//            vm.model = {
//                setting: {},
//                itemsListSplits: [],
//                lockedSave: false
//            };

//            // #endregion VARIABLES & DEFINITIONS

//            // #region TRANSLATE SERVICE

//            async function translate() {
//                let data = await translateService.translateBatch(translations);

//                Object.keys(translations).forEach((key) => {
//                    if (data?.[key]) translations[key] = data[key];
//                });
//            }

//            // #endregion TRANSLATE SERVICE

//            // #region LOAD PROCEDURE FUNCTION CALLS

//            async function loadSetting() {
//                vm.model.setting = (await consignmentSplitService.getSetting({ consignment_keyno_splitfrom: consignmentKeynoSplitFrom }))[0];
//            }

//            async function loadSplits() {
//                if (utilityService.validateParmsValue(vm.model.setting.consignment_keyno_splitfrom) !== true) return;
                
//                return vm.model.itemsListSplits = await consignmentSplitService.listSplits({ consignment_keyno_splitfrom: vm.model.setting.consignment_keyno_splitfrom });
//            }

//            // #endregion LOAD PROCEDURE FUNCTION CALLS

//            // #region TOGGLE FUNCTION
            
//            vm.toggleChosen = function (item) {
//                item = item?.item ? item.item : item;
                
//                if (item.item_id === '0') return;
//                if (item.item_id === '-1') return;
                
//                if (item.item_is_selected === '0') {
//                    item.item_is_selected = '1';
//                } else if (item.item_is_selected === '1') {
//                    item.item_is_selected = '0';
//                }
//            };

//            // #endregion TOGGLE FUNCTION

//            // #region BUTTON SAVE PROCEDURE FUNCTION CALL

//            vm.saveChanges = function () {
//                vm.model.lockedSave = true;
//                let selectedItems = [];

//                vm.model.itemsListSplits.forEach((item) => {
//                    selectedItems.push({
//                        item_id: item.item_id,
//                        item_is_selected: item.item_is_selected
//                    })
//                }); 

//                consignmentSplitService.saveObj({
//                    consignment_keyno_splitfrom: vm.model.setting.consignment_keyno_splitfrom,
//                    records: selectedItems
//                }).then(function (response) {
//                    if (response[0].errorcode !== '0') {
//                    	modalService.show({
//                    		type: 'warning',
//                    		title: translations.error,
//                    		message: response[0].errormessage,
//                    		buttons: [{
//                    			label: translations.ok,
//                    			cssClass: 'btn-warning',
//                    			action: function (dialogItself) {
//                    				dialogItself.close();
//                    				vm.model.lockedSave = false;
//                    			}
//                    		}]
//                    	});
//                    } else {
//                    	vm.model.lockedSave = false;
//                    	stateService.back();
//                    }
//                });
//            }

//            // #endregion BUTTON SAVE PROCEDURE FUNCTION CALL

//            // #region ON INIT FUNCTION

//            vm.$onInit = async function () {
//                translate();
//                await loadSetting();
//                loadSplits();
//            }

//            // #endregion ON INIT FUNCTION

//        }]
//    });
//})();
